// src/store/editor/selectors.js
import { createSelector } from '@reduxjs/toolkit'
import { selectObjects } from '~/store/live/selectors'
import { EMPTY_ARRAY } from '~/lib/constants'

const logger = console.scope('editor-selectors')

export const selectEditor = state => state.editor

// export const selectCurrentTool = createSelector(selectEditor, editor => editor.current_tool)

export const selectCurrentFill = createSelector(selectEditor, editor => editor.current_fill)

export const selectCurrentStroke = createSelector(selectEditor, editor => editor.current_stroke)

export const selectIsMasking = createSelector(selectEditor, editor => editor.is_masking)

export const selectIsTransforming = createSelector(selectEditor, editor => editor.is_transforming)

export const selectEditingGroupId = createSelector(selectEditor, editor => {
	const stack = editor.editing_group_stack
	return stack.length ? stack[stack.length - 1] : null
})

export const selectEditingGroupStack = createSelector(selectEditor, editor => editor.editing_group_stack)

export const selectEditingTextId = createSelector(selectEditor, editor => editor.editing_text_id)

export const selectExpandedLayerIds = createSelector(selectEditor, editor => ['root', ...editor.expanded_layer_ids])

export const selectIsExpanded = createSelector([selectExpandedLayerIds, (_, id) => id], (expandedIds, id) =>
	expandedIds.includes(id)
)

export const selectSelectedObjectIds = state => state.selection.objectIds || EMPTY_ARRAY

export const selectSelectedObjects = createSelector(selectObjects, selectSelectedObjectIds, (objects, selectedIds) => {
	return selectedIds.map(id => objects[id])
})

// Pure function — also used by LayersPanel for preview rendering
export const computeVisibleLayers = (objects, expandedIds) => {
	if (!objects?.root) return []
	const layers = []
	const addChildren = (group, indent) => {
		if (!expandedIds.includes(group.id)) return
		group.expanded = true
		;(group.children || []).forEach(childId => {
			if (!objects[childId]) {
				logger.warn('selectVisibleLayers: dangling child reference', childId)
				return
			}
			const child = { ...objects[childId], indent }
			if (group.locked) child.locked = true
			addChildren(child, indent + 1)
			layers.push(child)
		})
	}
	const root = { ...objects['root'] }
	addChildren(root, 0)
	return layers
}

export const selectVisibleLayers = createSelector(selectObjects, selectExpandedLayerIds, computeVisibleLayers)

export const selectIsSelected = createSelector([selectSelectedObjectIds, (_, id) => id], (ids, id) => ids.includes(id))
